<div class="row">
    <div class="col-12 pl-4">
        <yt-fw-default-update-buttons #defaultUpdateButtons>
                <div class="btn-group mr-2">
                    <button class="btn btn-outline-primary" type="button">
                        <i class="fa fa-fw fa-print"></i>
                        <span style="padding-left: 5px;" translate="FINDOKUMENT.STAMPAJDOKUMENT.SINGULAR"></span>
                        <!-- <span class="fa fa-fw fa-print"></span>Štampaj dokument -->
                    </button>
                </div>
                <div class="btn-group mr-2">
                    <button class="btn btn-outline-primary" type="button">
                        <i class="fa fa-fw fa-print"></i>
                        <span style="padding-left: 5px;" translate="FINDOKUMENT.ZAKNJIGOVODJU.SINGULAR"></span>
                        <!-- <span class="fa fa-fw fa-print"></span> Za knjigovođu -->
                    </button>
                </div>
                <div class="mr-2">
                    <h2 style="display:inline-block; color: #71b1d1">
                        <span *ngIf="baseUpdate.Item.ID <= 0"><span translate="FINDOKUMENT.NEW"></span></span>
                        <span *ngIf="baseUpdate.Item.ID > 0">
                            <span translate="FINDOKUMENT.BRNAL.SINGULAR"></span>
                            <span style="padding-left: 5px">{{baseUpdate.Item.BrojDokumenta}}</span>
                        </span>
                    </h2>
                </div>
        </yt-fw-default-update-buttons>
    </div>
    <!-- <div class="col-md-8 pl-4">
        <div class="btn-group ml-1">
            <button class="btn btn-outline-primary" type="button" >
                <span class="fa fa-fw fa-print"></span>Štampaj dokument
            </button>

            <button class="btn btn-outline-primary" type="button" >
                <span class="fa fa-fw fa-print"></span> Za knjigovođu
            </button>
        </div>
    </div> -->
<!-- [disabled]="baseFormGroup.get('ID').value==-1 || baseFormGroup.dirty" -->

<!-- <div class="btn-group ml-1">
    <button class="btn btn-outline-primary" type="button" >
        <span class="fa fa-fw fa-print"></span>Štampaj dokument
    </button>

    <button class="btn btn-outline-primary" type="button" >
        <span class="fa fa-fw fa-print"></span> Za knjigovođu
    </button>
</div> -->

</div>
<yt-fin-dokument-update #baseUpdate></yt-fin-dokument-update>